/* eslint-disable react/prop-types */
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import TermsStyleWrapper from './TermsStyleWrapper';
import RentalTermsOfUse from './RentalTermsOfUse';

class TermsPage extends React.Component {
  render() {
    const { brand, match = {} } = this.props;
    const MATCHED_URL = match.path.replace('(.*)', '');

    const RENTAL_TERMS_OF_USE_PATH = `${MATCHED_URL}/Rental-User-Terms`;

    return (
      <TermsStyleWrapper>
        <Switch>
          <Route exact path={RENTAL_TERMS_OF_USE_PATH} render={() => <RentalTermsOfUse brand={brand} />} />
        </Switch>
      </TermsStyleWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
});

// no auth check required on terms pages
export default withRouter(connect(mapStateToProps)(TermsPage));
